import { Button } from "./ui/button";
import BingoldLogo from "./BingoldLogo";
import {
  Github,
  Twitter,
  Send,
  MessageCircle,
  Mail,
  ExternalLink,
  Facebook,
  Instagram,
  Youtube,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const socialLinks = [
    {
      name: "Facebook",
      icon: Facebook,
      url: "https://www.facebook.com/bigodtoken/",
      color: "hover:text-blue-400",
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: "https://x.com/BiGODToken",
      color: "hover:text-blue-400",
    },
    {
      name: "Telegram",
      icon: Send,
      url: "https://t.me/+l_SYVIc9gPkyNzk1",
      color: "hover:text-blue-500",
    },
    {
      name: "Instagram",
      icon: Instagram,
      url: "https://www.instagram.com/bigod.token/",
      color: "hover:text-purple-400",
    },
    {
      name: "YouTube",
      icon: Youtube,
      url: "https://www.youtube.com/@bigodtoken",
      color: "hover:text-gray-300",
    },
  ];

  const links = {
    platform: [
      { name: "How It Works", href: "#features" },
      { name: "Active Campaigns", href: "#airdrop" },
      { name: "WhitePaper", href: "https://bingold.to/whitepaper.pdf" },
      {
        name: "Token Contract",
        href: "https://bscscan.com/address/0x11526f93be5f26220e9c7eacb587edaebaa9f627",
      },
    ],
    // resources: [
    //   { name: "Documentation", href: "/docs" },
    //   { name: "API Reference", href: "/api" },
    //   { name: "Help Center", href: "/help" },
    //   { name: "Blog", href: "/blog" },
    // ],
    company: [
      { name: "About Us", href: "#about" },
      // { name: "Privacy Policy", href: "/privacy" },
      {
        name: "Terms of Service",
        href: "https://investor.bingold.to/terms-and-conditions",
      },
      { name: "Contact", href: "mailto:support@bingold.to" },
    ],
  };

  return (
    <footer className="bg-[#101727] text-white">
      <div className="container mx-auto px-4 md:px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <BingoldLogo size="large" className="mb-4" />
            <p className="text-gray-400 mb-6 leading-relaxed">
              The premier platform for earning BINGOLD tokens through verified
              social campaigns and community engagement.
            </p>

            <div className="space-y-4 text-lg">
              <div>HQ: Singapore | Vaults: Singapore</div>
              <div>
                <span>Website: </span>
                <Link to={"https://bingold.to/"}>www.bingold.to</Link>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center transition-colors ${social.color}`}
                    aria-label={social.name}
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Links Sections */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Platform</h3>
            <ul className="space-y-3">
              {links.platform.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* <div>
            <h3 className="text-lg font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-3">
              {links.resources.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors flex items-center"
                  >
                    {link.name}
                    <ExternalLink className="w-3 h-3 ml-1" />
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Company</h3>
            <ul className="space-y-3">
              {links.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-yellow-400 transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter Section */}
          <div className="">
            <div className="flex flex-col gap-4">
              <div className="space-y-5">
                <h3 className="text-xl font-semibold text-white">
                  Stay Updated
                </h3>
                <p className="text-gray-400">
                  Get notified about new campaigns and BINGOLD updates.
                </p>
              </div>

              <div className="flex flex-col gap-3">
                <div className="">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-yellow-500"
                  />
                </div>

                <Button className="bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700 px-6">
                  <Mail className="w-4 h-4 mr-2" />
                  Subscribe
                </Button>
              </div>

              <p className="text-gray-600 font-medium">
                No spam, subscribe at any time?
              </p>

              <div className="">UEN (202520458M)</div>
            </div>
          </div>
        </div>

        {/* Token Info */}
        {/* <div className="bg-gradient-to-r from-yellow-400/10 to-yellow-600/10 border border-yellow-500/20 rounded-2xl p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-2xl font-bold text-yellow-400 mb-2">BINGOLD</div>
              <div className="text-gray-400">Token Symbol</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-yellow-400 mb-2">BSC</div>
              <div className="text-gray-400">Blockchain</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-yellow-400 mb-2">1B</div>
              <div className="text-gray-400">Total Supply</div>
            </div>
          </div>
        </div> */}

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © All rights reserved Bingold Pte Ltd (Singapore)
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Built on BSC</span>
              <span>•</span>
              <span>Powered by Community</span>
              <span>•</span>
              <a
                href="/security"
                className="hover:text-yellow-400 transition-colors"
              >
                Security
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
